<script>
    import {offlineDatabases} from '../../Database.svelte';
    export let value;

    $: assessment_sync = $offlineDatabases[value];
</script>

{#if assessment_sync}
    {#if assessment_sync.syncStatus == -1}
        Syncing...
    {:else if assessment_sync.syncStatus == 2}
        Error
    {:else}
        Synced
    {/if}
{:else}
    Not Synced
{/if}